import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({ onChange, ...props }) => {
  return (
    <ReCAPTCHA
      sitekey="6Lfg9FsgAAAAAGKVgxlXTR6koReeUTzGon3HsH1k"
      onChange={onChange}
      {...props}
    />
  );
};

export default ReCaptcha;
